import { Table as ReactAriaTable, TableProps } from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableProperties = TableProps & {
    className?: string
}

export const Table = ({
    className,
    ...properties
}: Readonly<TableProperties>): JSX.Element => {
    return (
        <ReactAriaTable
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
